import { render, staticRenderFns } from "./LandingCheckbox.vue?vue&type=template&id=2c0a6261&scoped=true&"
import script from "./LandingCheckbox.vue?vue&type=script&lang=ts&"
export * from "./LandingCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./LandingCheckbox.vue?vue&type=style&index=0&id=2c0a6261&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a6261",
  null
  
)

export default component.exports